import { Input, QueryList, ViewChildren, Directive } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SearchBaseRequest, SearchBaseResponse } from '../../../../modules/tcm-core.module';
import { Subscription } from "rxjs";
import { EntityPermissionNode, SpecialActionAccesses, SpecialActionNode } from "../../../../models/roles";
import { SecureBaseComponentContext } from "../../../../modules/tcm-common/services/secure-base-component-context.service";
import { PermissionsConsumer } from "../../../../components/permissions-consumer";
import { PermissionsInfo } from "../../../../components/permissions-info";
import { TcmBaseSearch } from "../../base/tcm-base-search";
import { ActionButtonDirective } from "../../directives/action-button.directive";
import { NullObjectSpecialActions } from '../null-object-special-actions';
@Directive()
export abstract class BaseSecureSearch<TRequest extends SearchBaseRequest, TResponse extends SearchBaseResponse<any>> extends TcmBaseSearch<TRequest, TResponse> implements PermissionsConsumer {

    @ViewChildren(ActionButtonDirective)
    private buttons: QueryList<ActionButtonDirective>;

    get canEdit() {
        return this.entityPermissions && this.entityPermissions.canEdit && this.checkAdditionalCanEditRules();
    }

    get specialActionPermissions(): SpecialActionAccesses {
        return this.componentContext.permissionService.currentPermissions
            ? this.componentContext.permissionService.currentPermissions.specialActions
            : NullObjectSpecialActions.specialActions;
    }

    @Input()
    set permissionsInfo(permissionsInfo: PermissionsInfo) {
        if (!this._permissionsInfo) {
            this._permissionsInfo = permissionsInfo;
            this.setPermissionsInfo(permissionsInfo);
        }
    }

    private entityPermissions: EntityPermissionNode;
    private permissionsSubscription: Subscription;
    private buttonsSubscription: Subscription;
    private _permissionsInfo: PermissionsInfo;

    constructor(protected override componentContext: SecureBaseComponentContext, protected override route: ActivatedRoute) {
        super(componentContext, route);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();

        this.permissionsInfo = this.route.snapshot.data as PermissionsInfo;

        this.buttonsSubscription = this.buttons.changes.subscribe(() => this.setupButtonsPermissions());
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        if (this.permissionsSubscription) {
            this.permissionsSubscription.unsubscribe();
        }

        this.buttonsSubscription.unsubscribe();
    }

    protected override onViewModelChanged() {
        super.onViewModelChanged();

        this.setSearchReadonlyIfNeeded();
    }

    protected setSearchReadonlyIfNeeded() {
        this.setupButtonsPermissions();
    }

    protected checkAdditionalCanEditRules() {
        return true;
    }

    private setPermissionsInfo(permissionsInfo: PermissionsInfo) {
        
        const { areaPermissionKey, entityPermissionKey } = permissionsInfo;

        if (areaPermissionKey && entityPermissionKey) {

            this.permissionsSubscription = this.componentContext.permissionService.getEntityPermissions$(areaPermissionKey, entityPermissionKey).subscribe(x => {
                if (x) {

                    if (x.canRead !== true && this.isRootComponent === true) {

                        this.goBack();

                        return;
                    }

                    const isInitial = !this.entityPermissions;

                    this.entityPermissions = x;

                    if (!isInitial) {
                        this.setupButtonsPermissions();
                    }
                }
            });
        }
    }

    private setupButtonsPermissions() {

        setTimeout(() => {
            this.buttons.forEach(x => {
                let makeDisplayed = false;

                if (x.specialAction) {
                    const sap: SpecialActionNode = this.specialActionPermissions[x.specialAction];

                    makeDisplayed = sap && sap.canExecute === true;
                }
                else if (x.permissions) {
                    const area = this.componentContext.permissionService.currentPermissions.entities[x.permissions.areaPermissionKey];
                    if (area) {
                        const entity = area[x.permissions.entityPermissionKey];
                        makeDisplayed = entity && entity.canEdit === true;
                    }
                }
                else {
                    makeDisplayed = this.canEdit;
                }

                x.toggleDisplay(makeDisplayed);
            });
        }, 0);
    }
}
